import editableAttributes from './editableAttributes.js';

export default function(feature, callback) {
  var content = document.getElementById('rwg-dialog-content');
  var h3 = document.createElement('h3');
  var form = document.createElement('form');
  var button = document.createElement('button');

  h3.textContent = 'Attributes';
  form.className = 'justifiedLabels';
  form.appendChild(h3);
  form.appendChild(editableAttributes(feature));

  button.type = 'submit';
  button.textContent = 'OK';
  button.className = 'rwg-btn';

  form.appendChild(button);
  form.onsubmit = function(evt) {
    evt.preventDefault(); // to stop the form from submitting
    content.innerHTML = '';
    document.getElementById('rwg-dialog').style.display = 'none';
    callback();
    return false;
  };

  content.appendChild(form);
  content.style.width = '25em';
  document.getElementById('rwg-dialog').style.display = 'block';
  let labelElement = form.querySelector('[name=label]');
  if (labelElement) labelElement.focus();
}
